import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTouristLevy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 530 440",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1.25,0,0,-1.25,0,440)",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "scale(.24)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m400.25,1190.25h236v169c.277,61.98 55.551,101.13 121,101-.48.13 253,0 253,0 65.56.13 119.91-39.02 120-101v-169h239v-1183h-969v1183" }),
				/* @__PURE__ */ _jsx("path", { d: "m311.25 9.25h-130c-89.582-0.16016-176.52 65.75-177 180 0 0 0.47656 821.17 0 823 0.47656 102.33 85.332 179.57 177 180h130v-1183" }),
				/* @__PURE__ */ _jsx("path", {
					d: "m723.25 1190.2h317v175h-317v-175z",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", { d: "m1455.25,9.25h130c89.75-.16016 176.69,65.75 177,180 0,0-.31,821.17 0,823-.31,102.33-85.17,179.57-177,180h-130v-1183" })
			]
		})
	})]
});
const ForwardRef = forwardRef(SvgTouristLevy);
export { ForwardRef as ReactComponent };
